export const isFullStatic = false
export const staticPath = "/tmp/build_453bf6d7/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"